import { useEffect } from 'react';

// Third-party
import Typography from '@mui/material/Typography';

// Hooks
import { useTranslation } from 'react-i18next';
import { useClock } from '../hooks/useClock';
import { useAppSelector } from '../../../hooks/useAppStore';

// Redux-toolkit
import { getShiftDetails } from '../../../store/clock/selectors';

const BreakTimer = () => {
  const {
    breakTime, timeBegan, clearTimer, startCounter,
  } = useClock();
  const shiftDetails = useAppSelector(getShiftDetails);
  const { t } = useTranslation('clock');

  useEffect(() => {
    if (shiftDetails.inBreak) {
      timeBegan.current = new Date(shiftDetails.breakStart);
      startCounter();
    }
    return () => {
      clearTimer();
    };
  }, [shiftDetails.inBreak]);

  return (
    <>
      <Typography
        sx={{
          color: 'text.secondary',
        }}
        variant="body2"
      >
        {t('currentBreak')}
      </Typography>
      <Typography paddingTop={1} variant="caption">
        {breakTime}
      </Typography>
    </>
  );
};

export {
  BreakTimer,
};
